import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import LinkButton from '@atlaskit/button/link';

type Props = {
	helpUrl?: string;
	isInsertEnabled: boolean;
	onClose: () => void;
	onConfirmInsert: () => void;
};

export const RegistryElementBrowserFooter = ({
	helpUrl,
	isInsertEnabled,
	onClose,
	onConfirmInsert,
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<>
			{helpUrl && (
				<LinkButton appearance="subtle" href={helpUrl} target="_blank">
					{formatMessage({ defaultMessage: 'Help', id: 'editor.quick-insert.help' })}
				</LinkButton>
			)}
			<Button appearance="subtle" onClick={onClose}>
				{formatMessage({ defaultMessage: 'Close', id: 'editor.quick-insert.close' })}
			</Button>
			<Button appearance="primary" isDisabled={!isInsertEnabled} onClick={onConfirmInsert}>
				{formatMessage({ defaultMessage: 'Insert', id: 'editor.quick-insert.insert' })}
			</Button>
		</>
	);
};
